import { render } from "./SectionBackdrop.vue?vue&type=template&id=32ade3e9&scoped=true"
import script from "./SectionBackdrop.vue?vue&type=script&lang=js"
export * from "./SectionBackdrop.vue?vue&type=script&lang=js"

import "./SectionBackdrop.vue?vue&type=style&index=0&id=32ade3e9&scoped=true&lang=css"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.21_vue@3.5.21_webpack@5.101.3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32ade3e9"]])

export default __exports__